import { render, staticRenderFns } from "./narcoticMedication.vue?vue&type=template&id=2c5cfc3d"
import script from "./narcoticMedication.vue?vue&type=script&lang=js"
export * from "./narcoticMedication.vue?vue&type=script&lang=js"
import style0 from "./narcoticMedication.vue?vue&type=style&index=0&id=2c5cfc3d&prod&lang=css"
import style1 from "./narcoticMedication.vue?vue&type=style&index=1&id=2c5cfc3d&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports